module.exports = require("./es-AR.js");